module.exports = require('./helpers/bundle-url').getBundleURL('eiBOl') + "logo.c51670a8.svg";